import { paths } from 'src/routes/paths';
import axios, { endpoints } from 'src/utils/axios';
import handleOKRequest from 'src/components/grids/generic-grid/handleOKRequest';
import handleBadRequest from 'src/components/grids/generic-grid/handleBadRequest';
import { createAsyncThunk } from '@reduxjs/toolkit';

//Modificar de acuerdo a la lógica de la acción
export const marcarEnviadoRemitoF = createAsyncThunk(
  'remitoForm/marcarEnviadoRemitoF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        endpoints.actions.marcarEnviadoRemitoF,
        data
      );
      handleOKRequest(response, 'Acción ejecutada correctamente.');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al ejecutar la acción.'
      );
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const marcarRecepcionadoRemitoF = createAsyncThunk(
  'remitoForm/marcarRecepcionadoRemitoF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        endpoints.actions.marcarRecepcionadoRemitoF,
        data
      );
      handleOKRequest(response, 'Acción ejecutada correctamente.');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al ejecutar la acción.'
      );
    }
  }
);
